






import { Component, Prop, Vue } from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import { UnitSystem } from '@/interfaces/units';
import { IPerRoadScenarioImperial, IPerRoadScenarioMetric } from '@/modules/perRoad/interfaces/perRoad';
import ProbabilisticInputs from '@/modules/lcca/views/components/ProbablisticInputs.vue';
import { perRoadStore } from '@/store/store';

const echarts = require('echarts');

@Component({
  components: {
    ProbabilisticInputs,
    QuickHelp,
    PxTextEntryBox,
    PxTextArea,
    ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class PrVehicleDistributionPlot extends Vue {
  @Prop() scenario!: IPerRoadScenarioImperial | IPerRoadScenarioMetric;

  @Prop({ default: 0 }) id!: number;

  @Prop({ default: 0 }) externalKey!: number;

  // @PropSync('alternative') alt!: ILccaAlternative;
  plotKeyInternal = 0;

  get plotKey() {
    return this.plotKeyInternal + this.externalKey;
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.$emit('sync');
  }

  mounted() {
    this.createPlot();
  }

  updated() {
    this.createPlot();
  }

  get plotId() {
    return `vehicle-distribution-plot-${this.id}`;
  }

  createPlot() {
    const el = document.getElementById(this.plotId);
    const chart = echarts.init(el);

    const series = [
      {
        type: 'bar',
        name: 'Class',
        data: this.scenario.vehiclesPctAadt.map((aadt, i) => [i + 5, aadt]),
        animation: false,
      },
    ];
    console.log(series);
    
    chart.setOption({
      grid: {
        top: 10,
        right: 25,
        bottom: 40,
        left: 60,
      },
      tooltip: {
        trigger: 'axis',
        formatter(obj: any) {
          return `<div>${obj[0].seriesName} ${obj[0].value[0].toFixed(0)}: ${obj[0].value[1].toFixed(2)}%</div>`;
        },
      },
      xAxis: {
        name: 'Vehicle Class',
        nameLocation: 'middle',
        nameGap: 30,
        scale: true,
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: true,
          text: 'Vehicle Class',
        },
      },
      yAxis: {
        name: '% AADT',
        nameLocation: 'middle',
        nameGap: 30,
        axisLabel: {
          show: true,
          text: '% AADT',
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series,
    });
  }

// updatePlotKey() {
//   this.modulusKey += 1;
//   console.log('moduluskey', this.modulusKey);
// }
}
